import { useQuery } from "@tanstack/react-query"

import { bffApi } from "../apiClient"
import formatDateStringToYYMMDD from "../helpers/formatDateStringToYYMMDD"
import { UserCard } from "../models"
import queryKeys from "../queryKeys"

const useUserCardsQuery = () => {
  return useQuery<UserCard[]>({
    queryKey: queryKeys.userCards,
    queryFn: async () => {
      const res = await bffApi.get<{ cards: UserCard[] }>("/user-cards")
      return res.data.cards
    },
    select: (data) => {
      return data.map((card) => ({
        ...card,
        birthDate: formatDateStringToYYMMDD(card.birthDate),
      }))
    },
    staleTime: 5 * 60 * 1000,
  })
}

export default useUserCardsQuery
